import {
  type ChangeEvent,
  type FormEvent,
  useEffect,
  useRef,
  useState,
  type VFC,
} from 'react'

import { checkNowValitidyByZipCode } from 'shared/experiments/components/SerpNowPush/helpers'
// @ts-ignore
import nowLogo from 'shared/experiments/components/SerpNowPush/now_logo.svg'
import logger from 'shared/services/logger'
import Button from 'views/components/atoms/Button'
import IconCross from 'views/components/atoms/Icon/IconCross'
import Image from 'views/components/atoms/Image'
import InputTextWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import Modal from 'views/components/molecules/Modal'
import TextWithIcon from 'views/components/molecules/TextWithIcon'

type SerpNowPushModalProps = {
  setIsNowAvailable: (code: boolean) => void
  setZipCodeToCheck: (status: string) => void
  zipCodeToCheck: string
  deliveryDay: string
}

const SerpNowPushModal: VFC<SerpNowPushModalProps> = ({
  setIsNowAvailable,
  setZipCodeToCheck,
  zipCodeToCheck,
  deliveryDay,
}) => {
  const closeModalEl = useRef<HTMLDivElement>(null)
  const [zipcode, setZipCode] = useState(zipCodeToCheck)

  const onSubmitHandler = (event: FormEvent) => {
    event.preventDefault()
    setZipCodeToCheck(zipcode)
    closeModalEl.current?.click()
  }

  useEffect(() => {
    checkNowValitidyByZipCode(zipcode)
      .then(isNowAvailable => {
        setIsNowAvailable(isNowAvailable)
      })
      .catch(err => {
        logger.error(err)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipcode])

  useEffect(() => {
    setZipCode(zipCodeToCheck)
  }, [zipCodeToCheck])

  const handleZipCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    sessionStorage.setItem('zipCode', value)
    setZipCode(value)
  }

  return (
    <Modal
      id="SerpNowPushModal"
      size="small"
      isClientSideControlled
      hideCloseButton
      noPadding
      className="e-SerpNowPushModal u-text-align--center"
    >
      <div className="e-SerpNowPushModal__wrapper u-padding--sides">
        <div
          data-a11y-dialog-hide="true"
          ref={closeModalEl}
          className="e-SerpNowPushModal__modalCloser l-flex l-flex--justify-content--end u-color--white u-padding-small--bottom"
        >
          <TextWithIcon icon={<IconCross />}>Schließen</TextWithIcon>
        </div>
        <div className="u-background-color--background-light u-overflow u-border-radius u-padding">
          <Image
            className="u-margin--auto u-padding-small--bottom u-padding-x-small--top"
            src={nowLogo}
            alt="now-logo"
          />

          <h3>Now! Lieferung {deliveryDay}</h3>
          <p>
            Geben Sie Ihre Postleitzahl ein um zu prüfen, ob unsere Lieferung{' '}
            {deliveryDay} in Ihrem Liefergebiet verfügbar ist.
          </p>
          <form onSubmit={onSubmitHandler}>
            <InputTextWithFloatingLabel
              inputType="text"
              name="nowCheckPostCode"
              label="Ihre PLZ"
              required
              value={zipcode}
              onChange={handleZipCodeChange}
            >
              Ihre PLZ
            </InputTextWithFloatingLabel>
            <div className="u-margin--top">
              <Button type="submit" name="nowPostCodeCheckButton">
                Verfügbarkeit prüfen
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export default SerpNowPushModal
